export const SET_SHOP_INFORMATION = 'SET_SHOP_INFORMATION'



// WEBPACK FOOTER //
// ./src/types/shopInformation.js